import ZCopyright from './ZCopyright.vue'
export default ZCopyright
